import { ReleaseNote, RoadmapItem } from './release-notes.model';

/**
 * Changelog exibido em `/novidades`, em ordem reversa (versão mais recente primeiro).
 *
 * NAO adicionar entradas manualmente — use `npm run release:bump patch|minor|major`
 * (ver docs/adr/ADR-0023-versionamento-semiautomatico.md e
 * scripts/release-bump.mjs), que insere aqui uma entrada com `versao` igual
 * a `APP_VERSION` e a `package.json`, com título e itens marcados `TODO:`
 * para você completar em linguagem para o usuário final (o policial).
 *
 * `npm run release:check` falha se a versão publicada não tiver entrada
 * correspondente aqui, ou se ainda restar algum placeholder `TODO:`.
 *
 * Datas abaixo são ilustrativas — confirme com o responsável pelo release
 * antes de publicar.
 */
export const RELEASE_NOTES: ReleaseNote[] = [
  {
    versao: '1.1.63',
    data: '2026-11-03',
    titulo: 'Inclusão de pessoas com dados de contato incompletos',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Ao buscar uma pessoa pelo CPF para incluí-la no RAP, o Nexus passa a aceitar cadastros com informações de contato incompletas, permitindo continuar o atendimento sem erro.',
      },
    ],
  },
  {
    versao: '1.1.62',
    data: '2026-10-28',
    titulo: 'Planilha do painel de TCI no período do filtro',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'No painel de TCIs, Exportar CSV passa a gerar a planilha com os TCIs do período escolhido no filtro, na mesma quantidade do card Total de TCIs.',
      },
    ],
  },
  {
    versao: '1.1.61',
    data: '2026-10-25',
    titulo: 'Posição inicial da viatura no mapa',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Ao assumir a viatura ou abrir uma vistoria vinculada ao serviço, o Nexus envia a localização inicial para o mapa. Se a localização não puder ser confirmada, você recebe um aviso sem perder o serviço ou a vistoria.',
        reportadoPor: 'Cel Clauder — CeTI',
      },
    ],
  },
  {
    versao: '1.1.60',
    data: '2026-10-22',
    titulo: 'Relatório da pessoa em situação de rua mais completo',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao: 'No RAP de pessoa em situação de rua, a natureza de nível 1 passa a se chamar Atuação Policial Comunitária (Nível 1 - Portaria 1.231/21). O nível de risco 1 indica orientação sobre os serviços disponíveis. O tipo de área do local passa a ser área pública, área privada ou não identificado.',
      },
      {
        categoria: 'melhorado',
        descricao: 'O PDF passa a mostrar, nas informações adicionais, a motivação, o local, a ocupação, o protocolo de atendimento e o acompanhamento. Em cada pessoa, aparecem o tempo na rua, onde pernoita, as vulnerabilidades aparentes, os animais, o benefício, a fonte de sustento e o vínculo familiar.',
      },
    ],
  },
  {
    versao: '1.1.59',
    data: '2026-10-22',
    titulo: 'Acesso simplificado à minha viatura',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'As telas de viatura passam a usar o mesmo acesso do Nexus. A responsabilidade pela guarnição e as confirmações das alterações continuam preservadas.',
      },
    ],
  },
  {
    versao: '1.1.58',
    data: '2026-10-20',
    titulo: 'Serviço encerrado, tela pronta para outra viatura',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao: 'Ao encerrar o serviço, a tela confirma o encerramento, mostra o resumo e fica pronta para assumir outra viatura. O item do menu passa a se chamar Minha viatura.',
      },
    ],
  },
  {
    versao: '1.1.57',
    data: '2026-10-19',
    titulo: 'Minha viatura mais simples no celular',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Confira os dados da viatura em um card, edite a equipe com um único salvamento e acompanhe sua localização com mais clareza. As ações individuais ficam no menu de cada policial; o serviço continua até o encerramento.',
      },
    ],
  },
  {
    versao: '1.1.56',
    data: '2026-10-19',
    titulo: 'Localização integrada ao serviço da viatura',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Após enviar sua localização, o Nexus atualiza a posição da guarnição usando sua sessão. Quando essa atualização estiver pendente, a tela informa e tenta novamente sem perder a confirmação do envio.',
      },
    ],
  },
  {
    versao: '1.1.55',
    data: '2026-10-19',
    titulo: 'Atualização da localização da guarnição',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Corrigido o envio da localização durante o serviço de viatura para o servidor responsável pelo acompanhamento da guarnição. A confirmação continua sendo exibida somente após o recebimento pelo servidor.',
      },
    ],
  },
  {
    versao: '1.1.54',
    data: '2026-10-18',
    titulo: 'Assuma a viatura com uma confirmação',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Quando disponível para seu perfil, confirme a guarnição e assuma a viatura sem preencher a vistoria técnica. Informe quando estiver a pé, retorne à viatura ou encerre o serviço. A tela mostra quando sua localização foi confirmada pelo servidor.',
      },
    ],
  },
  {
    versao: '1.1.53',
    data: '2026-10-13',
    titulo: 'Localize os problemas da viatura com precisão',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'O desenho da viatura agora inclui rotolight e serve para localizar problemas já relatados. Você pode reposicionar as marcações mantendo o relato e suas fotos. O recebimento lista as vistorias pendentes e guarda as observações do gestor.',
      },
      {
        categoria: 'melhorado',
        descricao: 'No PDF e nos detalhes do RAP, agora é possível consultar as observações da solicitação e a versão registrada de cada pessoa envolvida.',
      },
    ],
  },
  {
    versao: '1.1.52',
    data: '2026-10-13',
    titulo: 'Vistoria de viatura mais simples no celular',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao: 'Quando a vistoria estiver disponível para seu perfil, confira um item por vez ou por grupo, veja as pendências antes de assinar e registre avarias pelo desenho ou pelo nome da peça. A câmera de evidências inicia na traseira. Leituras de combustível precisam ser confirmadas, e detalhes ainda não enviados ficam preservados durante a sessão.',
      },
    ],
  },
  {
    versao: '1.1.51',
    data: '2026-10-14',
    titulo: 'Rascunhos do RAP preservados ao retomar o registro',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao retomar um RAP neste dispositivo, as informações ainda não enviadas ao servidor, como depoimentos e detalhes do endereço, são recuperadas do rascunho. Ao salvar, o aplicativo informa se o registro chegou ao servidor ou ficou apenas no dispositivo.',
        reportadoPor: '2º Sgt F. Andrade',
      },
    ],
  },
  {
    versao: '1.1.50',
    data: '2026-10-09',
    titulo: 'Limites claros para fotos e vídeos nas evidências',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao adicionar fotos e vídeos ao RAP, o aplicativo informa quando a foto ainda ultrapassa 2 MB após a compressão ou quando o vídeo passa de 10 MB, para que você escolha um arquivo menor.',
      },
    ],
  },
  {
    versao: '1.1.49',
    data: '2026-09-24',
    titulo: 'Resgate de fauna mais simples de preencher',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'No resgate de fauna, o animal é escolhido só pelo nome. A quantidade é um número, e cada grupo de opções (idade, estado, contenção e comportamento) vem com um título.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'A foto do animal, da entrega ou da soltura aparece na hora, inclusive quando vem da galeria. Dá para escrever ou ditar o que a foto mostra antes de salvar.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Quando não há pessoas envolvidas, o RAP não pede mais se todos foram orientados e liberados. Essa pergunta vale só para pessoas.',
      },
    ],
  },
  {
    versao: '1.1.48',
    data: '2026-09-24',
    titulo: 'Resgate de animais mais direto',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'No resgate de fauna, o animal é localizado pelo nome popular. Em seguida o policial informa idade, condição, forma de contenção e comportamento. Animais iguais entram juntos; se algum for diferente, entra em outro registro.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'O destino de cada grupo de animais fica no encaminhamento: entrega a um órgão, soltura ou descarte. Na soltura é possível marcar o local no mapa e registrar fotos, que passam a fazer parte das evidências.',
      },
      {
        categoria: 'novo',
        descricao:
          'A lista de espécies do batalhão ambiental entra na busca, inclusive pets comuns em entrega, como calopsita, periquito-australiano e hamster.',
      },
    ],
  },
  {
    versao: '1.1.47',
    data: '2026-09-22',
    titulo: 'RAPs do BOPE no dia a dia',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Os registros de Operação Petardo, Operação Gerente e Varredura Antibombas ficam disponíveis para o preenchimento.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Na Operação Petardo, o objeto suspeito, o isolamento e a evacuação são registrados em separado. O desfecho informa se a desativação usou explosivo, e é possível marcar a presença da perícia da PCDF, do CBMDF e dos equipamentos empregados.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A Varredura Antibombas pede se o serviço foi preventivo ou reativo e amplia a lista de meios empregados, como espelho de inspeção, lanterna tática e fibroscópio.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Na Operação Gerente, o desfecho fica em rendição ou intervenção tática. Dá para registrar a duração da operação, as tentativas de resolução anteriores e se a pessoa foi entregue ao primeiro interventor, conduzida pela equipe ou encaminhada ao IML.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No uso da força, é possível registrar golpe contundente, granada de luz e som, granada de efeito moral e os danos materiais causados durante a ação.',
      },
    ],
  },
  {
    versao: '1.1.46',
    data: '2026-09-04',
    titulo: 'Sinistro de trânsito com veículo não identificado',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'Ao finalizar um RAP de Sinistro de Trânsito sem veículo cadastrado, agora é possível informar que o veículo não foi qualificado e registrar o motivo. A justificativa fica disponível para a conferência na homologação.',
      },
    ],
  },
  {
    versao: '1.1.45',
    data: '2026-09-02',
    titulo: 'Painel do RAP com números oficiais',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'O painel do RAP e a tela de fiscalização passam a mostrar os totais oficiais do sistema, com recortes de período, unidade e tipo mais confiáveis.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Toque numa barra ou fatia do painel (unidade, natureza, tipo ou situação) para filtrar os gráficos na hora. Os filtros ativos aparecem como chips e podem ser removidos um a um. Toque num ponto da linha do tempo para ver a lista daquele período.',
      },
      {
        categoria: 'novo',
        descricao:
          'O RAP de visita comunitária e solidária está liberado para o uso do dia a dia.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'O número de versão exibido no aplicativo volta à sequência correta das atualizações.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Os filtros do painel deixam de ficar aplicados sem aparecer na tela. A opção Minha Unidade passa a mostrar só a sua unidade, e os cards de uso da força, prisões, lesões e DF 360 deixam de piscar zero ou mostrar variação de 100% para baixo sem motivo.',
      },
    ],
  },
  {
    versao: '1.1.44',
    data: '2026-08-31',
    titulo: 'Pesquisa RAP com filtros mais claros',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'A Pesquisa RAP agora aplica corretamente a unidade selecionada e mostra, em badges, todos os filtros ativos. Toque em um badge para remover somente aquele filtro.',
      },
    ],
  },
  {
    versao: '1.1.43',
    data: '2026-08-31',
    titulo: 'Endereços do RAP integrados ao GEO',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'A busca e a seleção de endereço no RAP agora usam o GEO institucional, incluindo endereço obtido pelo mapa, região administrativa e CEP. Ao indicar que o local de atendimento é o mesmo da solicitação, todas essas informações são copiadas corretamente.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Ao informar manualmente o local da solicitação ou do atendimento, pesquise pelo CEP ou pelo endereço completo para receber sugestões mais precisas. Depois de selecionar uma opção, também é possível abrir o mapa e ajustar o ponto exato do atendimento.',
      },
    ],
  },
  {
    versao: '1.1.42',
    data: '2026-08-27',
    titulo: 'Registro de evidências em averiguações',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'O RAP de Averiguação agora permite incluir evidências, como fotografias, vídeos, áudios e documentos, quando forem pertinentes ao atendimento.',
      },
    ],
  },
  {
    versao: '1.1.41',
    data: '2026-08-27',
    titulo: 'Resgate de fauna e crime ambiental',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Novo RAP de Resgate de Fauna: informe modalidade (resgate, apreensão ou entrega), espécie e quantidade, condição e destino de cada animal. Morcego sugere encaminhamento à Zoonoses.',
      },
      {
        categoria: 'novo',
        descricao:
          'Antes de voltar ao quartel, use o Registro de campo para gravar o horário e a posição do fato. Sem GPS, o sistema não inventa coordenada.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No RAP de Crime Ambiental, registre flora com a origem do dado (estimado, medido, pericial ou informado), documentos produzidos e animais apreendidos na mesma ocorrência.',
      },
      {
        categoria: 'novo',
        descricao:
          'Painel ambiental com desfecho por espécie e por Região Administrativa, distinguindo óbito na chegada e óbito durante o atendimento.',
      },
    ],
  },
  {
    versao: '1.1.40',
    data: '2026-08-27',
    titulo: 'Registro de evidências em averiguações',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'O RAP de Averiguação agora permite incluir evidências, como fotografias, vídeos, áudios e documentos, quando forem pertinentes ao atendimento.',
      },
    ],
  },
  {
    versao: '1.1.39',
    data: '2026-08-26',
    titulo: 'Novas naturezas e registro de visitas',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'A busca de natureza do atendimento agora inclui Desacato, Desobediência, Receptação e Violação de domicílio, com sugestão automática do tipo de RAP adequado.',
      },
      {
        categoria: 'novo',
        descricao:
          'As equipes podem registrar visita comunitária e visita solidária no RAP, informando se houve contato, quem atendeu e, só com autorização, um telefone para retorno.',
      },
      {
        categoria: 'novo',
        descricao:
          'O comando passa a ter um painel de visitas comunitárias e solidárias, com produção por unidade e efetividade de contato, sem exibir dados pessoais.',
      },
    ],
  },
  {
    versao: '1.1.38',
    data: '2026-08-15',
    titulo: 'Mapa e busca de endereço mais estáveis',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao voltar da lista para o mapa no COPOM e no Sentinela, o mapa reaparece corretamente, sem ficar em tela cinza.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A busca de endereço inicia uma nova pesquisa quando o campo é limpo ou a tela é fechada sem escolher um local.',
      },
    ],
  },
  {
    versao: '1.1.37',
    data: '2026-08-14',
    titulo: 'Validação de horários da solicitação',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'O RAP agora informa e impede a finalização quando a data e hora da solicitação forem posteriores ao horário do chamado.',
      },
    ],
  },
  {
    versao: '1.1.36',
    data: '2026-08-13',
    titulo: 'RAP automático para ocorrências do COPOM',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Ocorrências despachadas pelo COPOM agora geram automaticamente um RAP pré-preenchido com os dados disponíveis do chamado, para que a equipe inicie o registro com mais agilidade.',
      },
      {
        categoria: 'novo',
        descricao:
          'No primeiro passo do RAP originado pelo CAD/COPOM, o policial pode alterar o tipo do atendimento(Tipo RAP). Ao confirmar, os campos, abas e validações passam a seguir o tipo selecionado.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'As tags recebidas nos metadados do chamado agora ficam disponíveis na visualização do RAP e na homologação, em Mais detalhes, quando existirem.',
      },
    ],
  },
  {
    versao: '1.1.35',
    data: '2026-08-12',
    titulo: 'Consulta de policiais aprimorada',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'A busca de policiais na Guarnição do Dia agora consulta diretamente a base de pessoas, com suporte a nome, CPF ou matrícula. Na escolha do Oficial de Dia, a consulta prioriza automaticamente o quadro de oficiais.',
      },
    ],
  },
  {
    versao: '1.1.34',
    data: '2026-08-07',
    titulo: 'RAP e visualização no celular aprimorados',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'No RAP de Crimes contra a Dignidade Sexual, a ausência de encaminhamento passa a ser uma recomendação que pode ser justificada no histórico, sem impedir a finalização do registro.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Telas com indicadores, opções e informações relacionadas agora aproveitam melhor o espaço no celular, mantendo os dados lado a lado quando isso facilita a consulta.',
      },
    ],
  },
  {
    versao: '1.1.33',
    data: '2026-08-07',
    titulo: 'Preenchimento e equipe do RAP',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'As recomendações de envolvidos, evidências e objetos por natureza agora aparecem como atenção, sem impedir a finalização do RAP. Quando não atendidas, permanecem registradas para conferência do Oficial de Dia na homologação e devem ser justificadas no histórico. Melhoria recomendada pelo Sgt Bandeira, do 3º BPM.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A equipe responsável pode ser ajustada manualmente no fechamento do RAP, inclusive para atendimentos de outra data. A alteração vale apenas para o registro e não modifica a guarnição cadastrada no aplicativo. Melhoria recomendada pelo Sgt Bandeira, do 3º BPM.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Na homologação e nas listas de RAP, a unidade responsável agora reflete a unidade operacional definida para o atendimento, inclusive quando ela é identificada pelo Cerco.',
      },
    ],
  },
  {
    versao: '1.1.32',
    data: '2026-08-07',
    titulo: 'Indicadores e encaminhamento mais confiáveis',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Os indicadores de DF 360, uso da força, prisões e lesões agora consideram somente RAPs finalizados ou homologados, deixando o acompanhamento operacional mais preciso.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'No encaminhamento do RAP, a lista de delegacias passa a mostrar todas as opções cadastradas, facilitando a localização da unidade correta.',
      },
    ],
  },
  {
    versao: '1.1.31',
    data: '2026-08-06',
    titulo: 'Consultas e registros de RAP aprimorados',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Na consulta DF360, agora é possível filtrar os resultados pela origem da informação, facilitando a localização dos dados necessários ao atendimento.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Os indicadores do dashboard agora respeitam o período selecionado e deixam de repetir consultas, apresentando dados mais consistentes para o acompanhamento operacional.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No RAP de Violência Doméstica, o registro pode ser finalizado com uma única pessoa envolvida identificada, mantendo o preenchimento adequado ao atendimento realizado.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'A lista de delegacias no encaminhamento agora exibe todas as DPs cadastradas. Antes, apenas as primeiras opções apareciam ao abrir a lista, o que podia dar a impressão de que a delegacia procurada não estava cadastrada.',
      },
    ],
  },
  {
    versao: '1.1.30',
    data: '2026-08-06',
    titulo: 'Indicadores do dashboard mais precisos',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'No dashboard de RAPs, os rankings por unidade agora respeitam o indicador selecionado, incluindo registros finalizados, homologados e ocorrências com uso da força.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'O cadastro de armas foi ajustado para utilizar corretamente o modelo de dados do catálogo, preservando as informações selecionadas no RAP.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No RAP de Violência Doméstica, basta identificar ao menos uma pessoa envolvida para finalizar o registro, preferencialmente a VÍTIMA. O papel deve refletir o atendimento, como vítima, vítima fatal, autor, suspeito ou testemunha.',
      },
    ],
  },
  {
    versao: '1.1.29',
    data: '2026-08-04',
    titulo: 'Registro de MPOF corrigido',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao registrar uso de instrumento de menor potencial ofensivo, o formulário agora exibe a forma de emprego exigida e solicita a região corporal para taser e munição de impacto. Em “Outro instrumento”, informe também qual meio foi utilizado.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'No cadastro da guarnição, a busca manual do Oficial de Dia volta a autenticar corretamente a consulta de policiais.',
      },
    ],
  },
  {
    versao: '1.1.28',
    data: '2026-08-03',
    titulo: 'Pesquisa RAP disponível',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'A nova Pesquisa RAP permite localizar registros finalizados ou homologados por número, período e unidade. Ao tocar no resultado, consulte os detalhes completos do atendimento.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A pesquisa passa a informar que as consultas e visualizações são registradas para assegurar a rastreabilidade e a responsabilidade operacional.',
      },
    ],
  },
  {
    versao: '1.1.27',
    data: '2026-08-01',
    titulo: 'Endereço do RAP preenchido pelo GPS',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao iniciar um RAP, com a localização autorizada, o sistema sugere automaticamente o endereço do atendimento a partir do GPS. Confira os dados e corrija-os, se necessário, antes de finalizar o registro.',
      },
    ],
  },
  {
    versao: '1.1.26',
    data: '2026-08-01',
    titulo: 'Cronograma do RAP mais claro',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'No cronograma do RAP, a saída da delegacia agora é identificada com mais clareza e os horários já registrados exibem um lápis para indicar que podem ser corrigidos.',
      },
    ],
  },
  {
    versao: '1.1.25',
    data: '2026-07-31',
    titulo: 'Cadastro de pessoa aprimorado',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao atualizar uma pessoa, endereço, telefones e demais dados informados passam a ser preservados e exibidos corretamente nas consultas.',
      },
    ],
  },
  {
    versao: '1.1.24',
    data: '2026-07-31',
    titulo: 'Filtro personalizado na Lista de RAPs',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Na Lista de RAPs, agora é possível escolher uma data inicial e uma data final para consultar os registros de um período específico.',
      },
    ],
  },
  {
    versao: '1.1.23',
    data: '2026-07-30',
    titulo: 'Exportação de PDF do RAP aprimorada',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'Agora é possível gerar o PDF também para registros finalizados. O botão de PDF foi destacado para facilitar sua identificação na tela do atendimento.',
      },
    ],
  },
  {
    versao: '1.1.22',
    data: '2026-07-29',
    titulo: 'Perfis de acesso aprimorados',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Os perfis de Comandante, Inteligência e Oficial de Dia agora acessam as funcionalidades do Nexus sem precisar receber uma permissão de acesso duplicada.',
      },
    ],
  },
  {
    versao: '1.1.21',
    data: '2026-07-29',
    titulo: 'Homologação de RAP e Sinistro de Trânsito aprimorados',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Os filtros da Homologação de RAP agora permanecem ativos ao alternar entre as abas Aguardando, Em Andamento e Homologados. Ao abrir a tela, a consulta passa a considerar os últimos 7 dias por padrão.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No RAP de Sinistro de Trânsito, o cadastro de pessoas envolvidas tornou-se opcional. Quando houver envolvidos identificados, seus dados de trânsito continuam sendo solicitados.',
      },
    ],
  },
  {
    versao: '1.1.20',
    data: '2026-07-27',
    titulo: 'Filtro de unidades dos chamados aprimorado',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'A seleção de unidades na tela de chamados passou a usar uma lista própria, com a região administrativa exibida como referência. As unidades escolhidas continuam salvas neste dispositivo.',
      },
    ],
  },
  {
    versao: '1.1.19',
    data: '2026-07-27',
    titulo: 'Evidências físicas do RAP e cadastro de veículo aperfeiçoados',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Objetos apreendidos agora são enviados junto das fotos e demais mídias do RAP, permanecendo registrados após salvar, sincronizar ou finalizar o atendimento.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Ao registrar veículo apreendido, a placa passou a ser obrigatória e é padronizada automaticamente em letras maiúsculas, sem espaços ou símbolos. O chassi agora possui campo próprio e opcional.',
      },
    ],
  },
  {
    versao: '1.1.18',
    data: '2026-07-24',
    titulo: 'PDF do RAP liberado para todos e melhorias no histórico da pessoa',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'A exportação do RAP em PDF (formato A4, com identidade visual da PMDF) está liberada para todos os usuários — disponível na visualização de RAPs homologados e na tela do Oficial de Dia.',
      },
      {
        categoria: 'novo',
        descricao:
          'Na aba Histórico da consulta de pessoa, registros originados de RAP agora permitem abrir o atendimento completo direto do card do histórico.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A apresentação dos registros na aba Histórico da consulta de pessoa foi reorganizada, facilitando a leitura das ocorrências de cada fonte.',
      },
      {
        categoria: 'novo',
        descricao:
          'Nova aba Redes na consulta de pessoa, com a linha do tempo de relacionamentos e o grafo de coenvolvidos identificados no histórico. O recurso está em validação e será liberado gradualmente.',
      },
    ],
  },
  {
    versao: '1.1.17',
    data: '2026-07-24',
    titulo: 'Histórico da pessoa reúne registros do Nexus e Genesis',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Na aba Histórico da consulta de pessoa, os registros do Nexus agora aparecem junto dos registros do Genesis, identificados pela origem. A consulta continua disponível mesmo para pessoas sem CPF, usando os identificadores cadastrados nas fontes.',
      },
    ],
  },
  {
    versao: '1.1.16',
    data: '2026-07-23',
    titulo: 'Empunhadura preventiva de arma, menu do RAP e ajustes nos tipos de atendimento',
    tipo: 'patch',
    itens: [
      {
        categoria: 'melhorado',
        descricao:
          'Empunhar a arma de fogo em posição de segurança, sem apontar para o suspeito e sem resistência, agora é registrado como "Sem uso da força" (N0) — antes era classificado no mesmo nível de quem apontou a arma (N4). O nível N4 passa a exigir que a arma tenha sido apontada contra o suspeito, durante abordagem ou emprego tático contra ameaça.',
        reportadoPor: 'Ten-Cel Arantes — Comissão POPs/PMDF',
      },
      {
        categoria: 'novo',
        descricao:
          'No nível "Sem uso da força" (N0), agora é possível marcar a caixa "Houve empunhadura preventiva de arma, sem apontamento" — um registro estatístico opcional que não altera o nível declarado.',
      },
      {
        categoria: 'melhorado',
        descricao:
          '"Cobertura tática" deixou de ser uma opção ao registrar um novo evento de arma de fogo, por não se encaixar mais na definição de uso da força com arma apontada. Eventos já registrados com essa opção continuam sendo exibidos normalmente.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'O tipo de RAP "Acidente de Trânsito" foi unificado com "Sinistro de Trânsito", evitando duas opções parecidas na seleção de tipo. RAPs antigos criados como "Acidente de Trânsito" continuam abrindo e sendo editados normalmente.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Nos RAPs de Apreensão de Arma e Apreensão de Drogas, o cadastro de um envolvido deixou de ser obrigatório — agora é possível registrar corretamente casos de material abandonado, sem autor identificado no local.',
      },
      {
        categoria: 'novo',
        descricao:
          'No menu de ações (⋮) dos cards de RAP, o botão "Sincronizar" agora salva de fato o atendimento no estado em que está, e o Oficial de Dia passa a poder excluir um RAP por fiscalização direto no menu do card da lista de homologação, sem precisar abrir o detalhe.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A opção "Visualizar" foi removida do menu de ações do card de RAP — clicar em qualquer parte do card já abre o atendimento.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'A exportação do RAP em PDF passou a ficar disponível somente para RAPs já homologados pelo Oficial de Dia — antes também aparecia em RAPs apenas finalizados, que ainda podem sofrer correção.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No PDF do RAP, o cronograma do atendimento passou a ser exibido em uma linha do tempo horizontal, mais fácil de acompanhar do que a tabela anterior.',
      },
      {
        categoria: 'novo',
        descricao:
          'No ajuste manual de horário do cronograma (ex.: corrigir o horário de "Cheguei"), agora também é possível corrigir a data, útil quando o atendimento atravessa a meia-noite.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'O campo de busca de policial no cadastro de guarnição não menciona mais busca por CPF — a busca é feita somente por nome.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Na lista de RAPs, o filtro antes chamado "Finalizados" passou a se chamar "Em homologação", deixando mais claro que esses atendimentos aguardam a análise do Oficial de Dia.',
      },
    ],
  },
  {
    versao: '1.1.15',
    data: '2026-07-21',
    titulo: 'Evidências excluídas não voltam mais e controle de apagar RAP',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o retorno indevido de fotos, áudios, vídeos e documentos já excluídos do RAP. Mesmo se a remoção acontecer enquanto o atendimento está sendo salvo, enviado ou sincronizado sem rede, a mídia deixa de reaparecer.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Evita duplicar mídias nas evidências quando o envio de vários arquivos falha no meio do processo — o que já foi enviado com sucesso não é reenviado.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Agora é possível apagar RAPs em andamento ou em revisão pelo próprio criador. RAPs já finalizados, homologados ou arquivados continuam protegidos contra exclusão.',
      },
    ],
  },
  {
    versao: '1.1.14',
    data: '2026-07-21',
    titulo: 'Correção na exclusão de mídias das evidências',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigida a exclusão de fotos, áudios, vídeos e documentos no RAP. Ao remover uma mídia das evidências, ela deixa de aparecer no atendimento e não volta mais ao salvar o rascunho.',
      },
    ],
  },
  {
    versao: '1.1.13',
    data: '2026-07-21',
    titulo: 'Correção da tela de autenticação travando ao abrir o app',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o travamento na tela "Processando autenticação..." que impedia alguns usuários de abrir o aplicativo. Agora, se ocorrer qualquer falha ao entrar, o app mostra uma mensagem clara com um botão para tentar novamente — sem precisar limpar dados ou reinstalar o aplicativo.',
      },
    ],
  },
  {
    versao: '1.1.12',
    data: '2026-07-20',
    titulo: 'Exportação do RAP em PDF com identidade visual da PMDF',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Agora é possível exportar um RAP completo em PDF (formato A4), com a identidade visual da PMDF. No botão de PDF você pode salvar o arquivo no dispositivo ou compartilhar (quando o aparelho permitir). O documento inclui identificação, solicitação, locais, cronograma, guarnição, envolvidos, relato, uso da força, evidências com miniaturas das fotos, encaminhamentos e dados de homologação. CPF e matrícula aparecem mascarados, conforme a LGPD. Disponível na visualização do RAP e, para RAPs homologados, na tela do Oficial de Dia.',
      },
    ],
  },
  {
    versao: '1.1.11',
    data: '2026-07-20',
    titulo: 'Estabilidade no RAP, evidências, sincronização e equipes de apoio',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o acesso ao aplicativo para evitar recarregamentos e interrupções indevidas durante a renovação da sessão.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'RAPs sem envolvidos agora podem ser abertos e visualizados normalmente, com as informações disponíveis apresentadas sem bloquear a consulta.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'O aplicativo agora busca a posição inicial do dispositivo antes de iniciar o acompanhamento contínuo, tornando o registro de localização mais confiável em aparelhos móveis.',
      },
      {
        categoria: 'novo',
        descricao:
          'Agora é possível registrar, no RAP, uma ou mais equipes (viatura e policiais) que apoiaram o atendimento, além da guarnição principal. O registro é feito no final da etapa de Encaminhamentos.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigida a sincronização de RAPs feitos sem rede: o mesmo atendimento não deve mais gerar vários RAPs no sistema quando a conexão volta ou o envio é tentado mais de uma vez.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o envio de fotos e arquivos do RAP: ao anexar várias mídias de uma vez, todas passam a ser salvas; ao regravar o RAP, as mídias já enviadas não são duplicadas; e agora é possível excluir uma evidência individual com a remoção refletida no sistema.',
      },
    ],
  },
  {
    versao: '1.1.10',
    data: '2026-07-17',
    titulo: 'Correção de datas futuras nos RAPs e seleção inteligente de tipo no COPOM',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigida a exibição de datas e horários futuros na lista de RAPs (ex.: horário do dia seguinte). O aplicativo agora usa sempre o horário local do dispositivo para registrar e exibir datas e horários operacionais.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Quando a data ou hora de um registro não é informada corretamente, o app agora exibe "Data não informada" em vez de mostrar por engano o horário atual.',
      },
      {
        categoria: 'novo',
        descricao:
          'Ao assumir um chamado do COPOM (190) para abrir um RAP, o app agora sugere automaticamente o tipo de atendimento mais adequado a partir da natureza informada pelo despachante — indo direto para o formulário quando há apenas uma opção, ou destacando a sugestão na tela de seleção quando há mais de uma.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'A narrativa e os relatos registrados durante o atendimento no COPOM (190) agora são aproveitados automaticamente ao criar o RAP a partir do chamado, em vez de serem perdidos.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido um caso em que, ao importar um chamado do COPOM (190) e buscar a natureza manualmente na tela de seleção de tipo, o chamado em andamento era descartado indevidamente.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Ao editar um marco do cronograma do RAP, o app agora impede definir um horário fora da ordem correta (antes do marco anterior ou depois do marco seguinte) e explica o limite na mensagem de erro.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'As listagens de RAPs (lista principal e homologação) agora carregam os registros em blocos com o botão "Carregar mais" e um botão para voltar ao topo, tornando a navegação mais fluida em listas longas.',
      },
    ],
  },
  {
    versao: '1.1.9',
    data: '2026-07-16',
    titulo: 'Consulta de RAPs por natureza constatada',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao abrir uma natureza no Dashboard RAP, a lista agora apresenta todos os registros que possuem aquela natureza constatada no atendimento.',
      },
    ],
  },
  {
    versao: '1.1.8',
    data: '2026-07-16',
    titulo: 'Filtros da homologação, fiscalização e reclassificação de tipo',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Ao abrir o detalhe de um RAP na homologação e voltar para a lista, os filtros aplicados (período, unidade, tipo, origem e aba) são mantidos — não é mais preciso refazê-los a cada visualização.',
        reportadoPor: 'Sgt Franklin — CeTI',
      },
      {
        categoria: 'melhorado',
        descricao:
          'No filtro avançado da homologação, a unidade agora oferece três opções: minha unidade (padrão), todas as unidades ou escolha de várias unidades ao mesmo tempo.',
        reportadoPor: 'Sgt Franklin — CeTI',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Não é mais possível finalizar um RAP sem Oficial de Dia designado e sem ao menos um policial na guarnição — essas exigências passam a valer sempre, independentemente da tela de fiscalização.',
        reportadoPor: 'Maj Leandro — CeTI',
      },
      {
        categoria: 'novo',
        descricao:
          'Disponível a tela de Fiscalização de Homologação para comandantes, inteligência e oficiais de dia, com visão da PMDF, ranking de unidades e detalhamento por oficial.',
      },
      {
        categoria: 'novo',
        descricao:
          'Quando a natureza informada ou constatada não combina com o tipo do RAP, o aplicativo sugere a reclassificação do tipo e permite confirmar a troca durante o preenchimento.',
        reportadoPor: 'TC Odorico',
      },
    ],
  },
  {
    versao: '1.1.7',
    data: '2026-07-15',
    titulo: 'Correção do filtro de unidade na homologação de RAPs',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'A fila de homologação de RAPs agora respeita corretamente a unidade selecionada nos filtros. Também é possível localizar um RAP pelo seu número nessa consulta.',
      },
    ],
  },
  {
    versao: '1.1.6',
    data: '2026-07-15',
    titulo: 'Novas naturezas do RAP e correções de horário e botões do wizard',
    tipo: 'patch',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Novas naturezas disponíveis no campo "Tipo de RAP": em "Apoio a Órgão", apoio a eventos do TJDFT, MPDFT, TRE e Procuradoria-Geral do DF e apoio a tribunais de júri; em "Cumprimento de Mandado", 14 naturezas de apoio a oficial de justiça (citação/intimação, reintegração de posse, despejo, penhora, condução coercitiva, entre outras).',
        reportadoPor: 'SD Danilo Alves — 12º BPM',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Os botões "Salvar", "Avançar" e "Enviar" do preenchimento do RAP não apareciam em alguns celulares Android na orientação vertical, ficando escondidos atrás do menu inferior do aplicativo. Agora eles ficam sempre visíveis, sem precisar girar a tela.',
        reportadoPor: 'SD Menegaz — 7º BPM',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o horário exibido em "Detalhes > Auditoria e Metadados" do RAP, que aparecia adiantado em cerca de 3 horas em relação ao horário de Brasília.',
        reportadoPor: 'SD Menegaz — 7º BPM',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Padronizada a exibição de horários no aplicativo: agora sempre no formato "14:35", sem misturar com a notação "14:35h".',
        reportadoPor: 'SD Menegaz — 7º BPM',
      },
    ],
  },
  {
    versao: '1.1.5',
    data: '2026-07-14',
    titulo: 'Correções no Oficial de Dia, homologação e endereço da abordagem',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'A designação do Oficial de Dia agora é feita direto no cadastro da guarnição (tela inicial), junto com a equipe e a viatura — com detecção automática pela escala de serviço, do mesmo jeito que já funciona para os demais policiais. Não é mais necessário informar o Oficial de Dia dentro do RAP.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Nova aba "Em Andamento" na tela de homologação de RAPs, reunindo em um só lugar os RAPs que ainda estão sendo preenchidos, em rascunho ou devolvidos para correção.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'A tela de homologação de RAPs agora mantém os filtros e a posição da lista ao abrir um RAP e voltar, e o botão "Carregar mais" passou a funcionar corretamente em todas as abas.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'O resumo do RAP agora exibe um mapa com a localização do atendimento, quando as coordenadas estiverem disponíveis.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o endereço preenchido automaticamente ao registrar uma abordagem: agora usa o endereço real obtido a partir da localização do GPS, em vez de ficar só com "A definir".',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o nome de guerra dos policiais da guarnição, que podia aparecer incorreto no RAP.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o número de versão e o percentual de preenchimento do RAP, que em alguns casos não avançavam corretamente ao salvar.',
      },
    ],
  },
  {
    versao: '1.1.4',
    data: '2026-07-13',
    titulo: 'Correção no passo Encaminhamentos do RAP',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigida a exibição da seção de naturezas constatadas no passo Encaminhamentos do RAP, que não estava aparecendo por uma falha de configuração. Agora é possível confirmar a natureza informada no acionamento ou registrar as naturezas realmente constatadas no local, com o motivo da divergência e a notificação ao COPOM.',
      },
    ],
  },
  {
    versao: '1.1.3',
    data: '2026-07-11',
    titulo: 'Correções no RAP e no Sentinela',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigida a exibição do Dashboard do RAP e da Central de Coordenação (dashboards de RAP, TCI e PROVID reunidos em um só lugar), que não estavam aparecendo por uma falha de configuração.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o horário exibido na narrativa de RAPs gerados a partir de alertas do Sentinela, que em alguns casos aparecia adiantado em relação ao horário real do atendimento.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'A narrativa gerada por IA para RAPs do Sentinela deixou de inventar desfechos não confirmados pelo policial (ex.: informar que um veículo não estava no local quando, na verdade, foi encontrado).',
      },
      {
        categoria: 'novo',
        descricao:
          'Ao registrar um resultado negativo em verificação do Sentinela, agora é possível informar o motivo: procurado ausente ou erro de reconhecimento do sistema (placa ou identificação facial).',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Reforçada a proteção de dados de crianças e adolescentes envolvidos em atendimentos: o nome deles não é mais enviado ao serviço de IA usado para redigir a narrativa do RAP.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido problema em que RAPs de outros policiais podiam aparecer na lista "Meus RAPs" ao filtrar por status. Adicionado o toggle "Somente meus" na lista de RAPs para alternar entre ver os RAPs da guarnição ou apenas os próprios.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Ao tentar abrir um RAP sem permissão, a mensagem agora informa claramente "Acesso não autorizado" em vez de indicar, por engano, que o RAP não foi encontrado.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Corrigido o status "Complementado" do encaminhamento à delegacia, que podia se perder ao reabrir o RAP.',
      },
      {
        categoria: 'melhorado',
        descricao:
          'Ajustes visuais nos passos de Uso da Força e Evidências do preenchimento do RAP.',
      },
    ],
  },
  {
    versao: '1.1.1',
    data: '2026-07-09',
    titulo: 'Correções no RAP',
    tipo: 'patch',
    itens: [
      {
        categoria: 'corrigido',
        descricao:
          'Corrigida a exibição de RAPs em andamento nos filtros "Meus RAPs" e "Homologação", que em alguns casos não apareciam na lista mesmo existindo.',
      },
      {
        categoria: 'corrigido',
        descricao:
          'Removidos temporariamente os tipos "Pessoa em Situação de Rua" e "Sensor de Inteligência" da seleção de novo RAP, enquanto o fluxo é validado com a área de negócio.',
      },
    ],
  },
  {
    versao: '1.1.0',
    data: '2026-07-08',
    titulo: 'Registro de Atividade Policial (RAP)',
    tipo: 'minor',
    itens: [
      {
        categoria: 'novo',
        descricao:
          'Criação e preenchimento do RAP em um assistente guiado por etapas, com envio de evidências.',
      },
      {
        categoria: 'novo',
        descricao: 'Homologação do RAP pelo Oficial de Dia, com devolução para correção quando necessário.',
      },
      {
        categoria: 'novo',
        descricao: 'Atalho rápido para iniciar um novo RAP direto do Início e da lista de RAPs.',
      },
      {
        categoria: 'melhorado',
        descricao: 'Registro de abordagem direto na tela de consulta de pessoa.',
      },
      {
        categoria: 'melhorado',
        descricao: 'Novos atalhos e indicadores de RAP no painel inicial.',
      },
    ],
  },
  {
    versao: '1.0.0',
    data: '2026-05-01',
    titulo: 'Lançamento do Nexus',
    tipo: 'major',
    itens: [
      { categoria: 'novo', descricao: 'Consulta de pessoa e de veículo, com reconhecimento facial.' },
      { categoria: 'novo', descricao: 'Registro e acompanhamento de Termos Circunstanciados de Infração (TCI).' },
      { categoria: 'novo', descricao: 'DF 360 (Sentinela): consulta de câmeras de reconhecimento facial e alertas.' },
      { categoria: 'novo', descricao: 'Central de chamados do COPOM.' },
    ],
  },
];

/**
 * Roadmap público exibido em `/novidades`. Linguagem de intenção, sem
 * compromisso de data — os itens seguem o painel de flags em
 * `.ai/memory/open-decisions.md`.
 */
export const ROADMAP: RoadmapItem[] = [
  {
    titulo: 'Sincronização automática do RAP',
    descricao: 'Envio automático de RAPs pendentes assim que a conexão com a internet for restabelecida.',
    status: 'planejado',
  },
  {
    titulo: 'Ordem de Serviço digital',
    descricao: 'Emissão e acompanhamento de ordens de serviço diretamente pelo aplicativo.',
    status: 'planejado',
  },
  {
    titulo: 'PROVID — Avaliação de Risco',
    descricao: 'Módulo de avaliação de risco e acompanhamento de casos de violência doméstica.',
    status: 'planejado',
  },
  {
    titulo: 'Abastecimento e vistoria de viaturas',
    descricao: 'Controle digital de abastecimento e vistoria de viaturas integrado ao SisFrota.',
    status: 'planejado',
  },
  {
    titulo: 'Notificações em tempo real',
    descricao: 'Atualizações instantâneas de chamados e alertas via conexão persistente.',
    status: 'em-desenvolvimento',
  },
];
